import React, { FC, useCallback } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { useDropzone } from 'react-dropzone';

type Props = {
  upload(file: File): void;
  allowClick?: boolean;
};

const AssetDropzone: FC<Props> = ({ upload, children, allowClick = false }) => {
  const onDrop = useCallback(
    (acceptedFiles: []) => {
      acceptedFiles.forEach((file) => {
        upload(file);
      });
    },
    [upload],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onDrop,
    multiple: true,
    noClick: !allowClick,
  });

  return (
    <Box
      {...getRootProps()}
      width={1 / 1}
      height={'100%'}
      overflow={'hidden'}
      overflowY="auto"
      bg={'transparent'}
      sx={{
        position: 'relative',
        filter: isDragActive ? 'brightness(0.8)' : 'brightness(1)',
        ':focus': { outline: 'none' },
      }}
    >
      <Flex variant={'dotted2'} alignItems="center" justifyContent="center">
        <Text color={'grey2'} textAlign="center">
          Drop assets
        </Text>
      </Flex>
      <input {...getInputProps()} />
      {children}
    </Box>
  );
};

export default AssetDropzone;
